import { MARKETS, COUNTRY_HR_EMAILS, CONTACT } from "./content";
import { PARTNERS } from "./partners";

export const MARKET_SLUGS = {
  se: "sweden", gb: "united-kingdom", pt: "portugal", pl: "poland", be: "belgium",
  es: "spain", de: "germany", dk: "denmark", no: "norway", fi: "finland", sa: "saudi-arabia",
};

export const marketPath = (code) => `/markets/${MARKET_SLUGS[code]}`;

export const marketBySlug = (slug) => {
  const code = Object.keys(MARKET_SLUGS).find((c) => MARKET_SLUGS[c] === slug);
  return code ? MARKETS.find((m) => m.code === code) : undefined;
};

export const marketHrEmail = (code) => COUNTRY_HR_EMAILS[code] || CONTACT.hrEmail;

// Partners whose own flags cover this market, otherwise the whole network.
export const marketPartners = (code) => {
  const matched = PARTNERS.filter((p) => (p.flags || [p.flag]).includes(code));
  return matched.length ? matched : PARTNERS;
};
